import { useEffect, useRef } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useUserPreferences } from '../hooks/useUserPreferences';

/**
 * Componente para carregar e aplicar preferências do usuário automaticamente
 * Deve ser usado dentro de rotas autenticadas
 */
export default function PreferencesLoader() {
  const { isAuthenticated, user } = useAuth();
  const { preferences, isLoading } = useUserPreferences();
  const hasLoadedRef = useRef(false);

  // Aplicar tamanho da fonte quando as preferências forem carregadas
  useEffect(() => {
    if (preferences?.font_size && !isLoading) {
      const fontSizeMap = {
        small: '0.75rem',
        medium: '0.875rem',
        large: '1rem'
      };
      const fontSize = fontSizeMap[preferences.font_size] || fontSizeMap.medium;
      document.documentElement.style.fontSize = fontSize;
    }
  }, [preferences?.font_size, isLoading]);

  // Log quando as preferências forem carregadas
  useEffect(() => {
    if (preferences && !isLoading && !hasLoadedRef.current) {
      hasLoadedRef.current = true;
    }
  }, [preferences, isLoading]);

  // Resetar flag quando usuário mudar
  useEffect(() => {
    if (!isAuthenticated || !user?.id) {
      hasLoadedRef.current = false;
    }
  }, [isAuthenticated, user?.id]);

  // Este componente não renderiza nada, apenas aplica preferências
  // O hook useUserPreferences já carrega as preferências automaticamente
  return null;
}

